import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UpdateUser, UpdateUserDefaultValues } from 'src/app/components/users/update-user';
import { ToastService } from 'src/app/services/toast-service.service';
import { UserService } from 'src/app/services/user.service';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
    selector: 'app-edit-participant-profile',
    templateUrl: './edit-participant-profile.component.html',
    styleUrls: ['./edit-participant-profile.component.scss'],
    standalone: false
})
export class EditParticipantProfileComponent {
  updateUser:UpdateUser=UpdateUserDefaultValues();
  userdbid: string = '';
  translations: any;
constructor(
  private userservice: UserService,
  private route: ActivatedRoute,
  private toastservice: ToastService,
  private router: Router,
  private translationService: TranslationService
) { }

  ngOnInit(): void {
    this.translationService.getTranslation().subscribe({
      next: (translations) => {
        this.translations = translations;
      }
    });

    this.userservice.getUserProfile().subscribe({
      next: (profile) => {
        this.userdbid = profile.id;
        this.userservice.getUserDetailsForUpdate(this.userdbid).subscribe({
          next: (response) => {
            this.updateUser = response;
          }
        });
      }
    });
  }

  onUpdate()
  {
    this.userservice.updateUser(this.updateUser).subscribe({
      next: (response) => {
        localStorage.setItem('agentname',this.updateUser.displayName)
        this.toastservice.showMessage(this.translations?.['profileUpdatedSuccessText'] || 'Profile updated successfully');
        this.router.navigate(['/dashboard-participant']);
      }
    })
  }
}
